import React, { useState, useRef } from 'react';
import LayoutOne from '../../layouts/LayoutOne';
import { useSelector } from 'react-redux';

const TermsPage = () => {
  const settings = useSelector((state) => state?.settings?.list[0]?.termsCond);
  const sectionRefs = useRef([]);
  // Extract keys from settings.privacy.sections (assuming this structure)
  const keys = settings?.privacy?.sections ? Object.keys(settings.privacy.sections) : [];
  const scrollToSection = (index) => {
    sectionRefs.current[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return (
    <LayoutOne>
      <div
        dangerouslySetInnerHTML={{ __html: settings }}
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "40px 24px",
          backgroundColor: "#ffffff",
          color: "#1f2937", // Tailwind gray-800
          fontFamily: "'Inter', sans-serif",
          fontSize: "16px",
          lineHeight: "1.7",
          borderRadius: "12px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
        }}
      />
      <style>
        {`
    .privacy-policy-container h1,
    .privacy-policy-container h2,
    .privacy-policy-container h3 {
      color: #111827;
      margin-top: 1.5em;
      margin-bottom: 0.5em;
      font-weight: 700;
      line-height: 1.3;
    }

    .privacy-policy-container h2 {
      font-size: 1.5rem;
      border-bottom: 2px solid #e5e7eb;
      padding-bottom: 0.3em;
    }

    .privacy-policy-container p {
      margin-bottom: 1.2em;
    }

    .privacy-policy-container ul,
    .privacy-policy-container ol {
      padding-left: 1.5rem;
      margin-bottom: 1.2em;
    }

    .privacy-policy-container li {
      margin-bottom: 0.5em;
    }

    .privacy-policy-container strong {
      font-weight: 600;
    }

    .privacy-policy-container a {
      color: #2563eb;
      text-decoration: underline;
    }

    .privacy-policy-container a:hover {
      color: #1d4ed8;
    }
  `}
      </style>

    </LayoutOne>
  );
};

export default TermsPage;